<template>
  <div class="main">
    <LoginTrigger></LoginTrigger>
    <div class="main-desktop">
      <DirectAccess></DirectAccess>
      <DecisionTree></DecisionTree>
    </div>
  </div>
</template>

<script>

import DecisionTree from '../components/DecisionTree.vue';
import DirectAccess from '../components/DirectAccess.vue';
import LoginTrigger from "../components/LoginTrigger.vue";


export default {
  components: { LoginTrigger, DirectAccess, DecisionTree },
  created(){
    this.saveCounter('rs.wpvisitor')
  },
  methods: {
    saveCounter: (counterName) => {
      if(window && window.SaveTracker) {
        window.SaveTracker(counterName)
      } else {
        const script = document.createElement('script')
        script.onload = () => window.SaveTracker(counterName)
        script.src = 'https://tracker.rastreator.com/scripts/v2/tracker.min.js'
        document.head.appendChild(script)
      }
    }
  }
  
};
</script>

<style lang="scss">

$fontdir: "../../core/core-framework/assets/";
@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/mixins/mixins";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_buttons";
@import "../../core/core-framework/assets/scss/inc/_shadows.scss";
@import "../../core/core-framework/assets/scss/inc/_fonts.scss";
@import "../../core/core-framework/assets/scss/inc/_icons.scss";

.main {
  background-color: #f7faff;
  @media screen and (min-width: $screen-sm) { height: auto; }
  @media screen and (min-width: 1900px) { height: 100%; }
}
.main-desktop { margin: 0 77px 50px; }

</style>
